import { AUDIENCIA_MODEL } from 'utils/models';
import api from './api';
import { ALERTAS_ROUTE, EMISSAO_ROUTE } from '../constants/apiRoutes';

function compare(a, b) {
	if (a.id < b.id) {
		return -1;
	}
	if (a.id > b.id) {
		return 1;
	}
	return 0;
}

function getCrepdecsFromGeo(municipios) {
	if (!municipios) return [];

	const listaCrepdecs = municipios.map(item => item.crepdec);

	const getUniqueValues = [...new Set(listaCrepdecs.map(item => item.id))].map(
		id => listaCrepdecs.find(a => a.id === id),
	);

	getUniqueValues.sort(compare);

	return getUniqueValues;
}

function getMunicipiosFromGeo(municipios) {
	if (!municipios) return [];

	const listaMunicipios = municipios.map(item => ({
		nome: item.nome, codigoIbge: item.codigoIbge,
	}));
	return listaMunicipios;
}

export default {
	async findAudienciaByAlertaId(id) {
		const { data } = await api.get(ALERTAS_ROUTE.FIND_BY_ID.replace('{alertaId}', id));

		/*
            Cria os arrays de municipios e crepdecs selecionados na etapa geo
        */
		const { municipios } = data.geo ? data.geo : [];
		const arrayCrepdecs = getCrepdecsFromGeo(municipios);
		const arrayMunicipios = getMunicipiosFromGeo(municipios);

		let { emissaoAlerta } = data;
		const { dadoParametrizado } = data;

		emissaoAlerta = emissaoAlerta || AUDIENCIA_MODEL;

		emissaoAlerta.alertaId = data.id;
		emissaoAlerta.alertaStatus = data.statusAtualAlerta;

		emissaoAlerta = {
			...emissaoAlerta,
			crepdecs: [
				...arrayCrepdecs,
			],
			municipios: [
				...arrayMunicipios,
			],
		};

		return { audiencia: emissaoAlerta, dadoParametrizado };
	},

	async saveAudiencia(audiencia) {
		return api.post(EMISSAO_ROUTE.CREATE, audiencia);
	},

	async emitirAlerta(audiencia) {
		try {
			/* Ultimo parametro enviado, serve para a api saber se irá exibir o sweet alert caso
                for o modulo de alertas, se encontra dentro de config
            */
			const response = await api.post(ALERTAS_ROUTE.EMIT_ALERTA, audiencia, { modulo: 'alertas' });
			return response;
		} catch (error) {
			return error.response.data;
		}
	},
};
